export const getArgosJobState = ({state, job_status, live_job}) => (
    live_job?.status?.state ?? state ?? job_status ?? null
);

export const canStartArgosJob = ({job_uuid}) => !job_uuid;

const STOP_ENABLED_STATES = new Set(['initializing_pipeline', 'running']);

export const canShowStopArgosJob = (job) => {
    if (!job.job_uuid) {
        return false;
    }

    const jobState = getArgosJobState(job);

    return 'terminated' !== jobState;
};

export const canEnableStopArgosJob = (job) => {
    const jobState = getArgosJobState(job);

    return STOP_ENABLED_STATES.has(jobState);
};

export const hasArgosJobStream = (job) => Boolean(
    job.live_job?.stream?.status
    || (null != job.stream_status && '' !== job.stream_status)
);

export const canShowReenqueueArgosJob = (job) => {
    if (!job.job_uuid || !hasArgosJobStream(job)) {
        return false;
    }

    return STOP_ENABLED_STATES.has(getArgosJobState(job));
};

export const getStopDisabledTooltip = (job) => {
    const jobState = getArgosJobState(job);

    if (jobState) {
        return `Cannot stop while \`${jobState}\``;
    }

    return 'Stop is only available while the job is initializing pipeline or running';
};
